import axios from "axios";

const instance = axios.create({
  baseURL: "",
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

export default instance;
